import { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';

export default function SplashScreen() {
  const app = useApp();
  const isInitialLoading = app?.isInitialLoading ?? false;
  
  const [fadingOut, setFadingOut] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!isInitialLoading) {
      setFadingOut(true);
      const timer = setTimeout(() => {
        setHidden(true);
      }, 700);
      return () => clearTimeout(timer);
    }
  }, [isInitialLoading]);

  if (hidden) return null;

  return (
    <div 
      className={`fixed inset-0 z-[9999] bg-white dark:bg-[#0A0A0C] flex flex-col items-center justify-center font-sans select-none transition-opacity duration-700 ease-in-out ${
        fadingOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(var(--theme-rgb),0.15),transparent_60%)] animate-pulse" />
      
      <div className="relative flex flex-col items-center space-y-8 px-6 text-center">
        
        {/* Animated Brand Logo */}
        <div className="relative flex justify-center items-center">
          <div className="absolute inset-0 rounded-full bg-primary animate-ping opacity-30 blur-md"></div>
          <div className="bg-primary w-20 h-20 sm:w-24 sm:h-24 rounded-3xl shadow-[0_0_40px_rgba(var(--theme-rgb),0.5)] flex items-center justify-center relative z-10 animate-pulse">
            <svg width="42" height="42" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white drop-shadow-md">
              <path fillRule="evenodd" clipRule="evenodd" d="M8 8V6a4 4 0 1 1 8 0v2h2.5A1.5 1.5 0 0 1 20 9.5v11a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 20.5v-11A1.5 1.5 0 0 1 5.5 8H8Zm2 0h4V6a2 2 0 1 0-4 0v2Zm2 10.5l-.6-.55c-2.1-1.9-3.6-3.4-3.6-5 0-1.3 1-2.3 2.3-2.3.7 0 1.4.3 1.9.8.5-.5 1.2-.8 1.9-.8 1.3 0 2.3 1 2.3 2.3 0 1.6-1.5 3.1-3.6 5l-.6.55z" fill="currentColor"/>
            </svg>
          </div>
        </div>

        {/* Brand Text */}
        <div className="text-center space-y-1.5">
          <h1 className="text-3xl md:text-4xl font-black tracking-[0.25em] text-neutral-900 dark:text-white drop-shadow-sm flex items-center justify-center">
            PRIYOFY<span className="text-primary text-4xl leading-[0]">.</span>
          </h1>
          <p className="text-[10px] uppercase tracking-[0.35em] text-neutral-500 dark:text-neutral-400 font-bold">
            Premium E-Commerce
          </p>
        </div>
        
        {/* Sleek Animated Progress Bar */}
        <div className="w-48 sm:w-64 flex flex-col items-center space-y-2.5 pt-2">
          <div className="w-full h-1.5 bg-neutral-100 dark:bg-neutral-800/80 rounded-full overflow-hidden relative border border-neutral-200/40 dark:border-neutral-700/30">
            <div className="absolute inset-y-0 bg-gradient-to-r from-pink-500 via-rose-500 to-purple-600 rounded-full w-2/3 animate-shimmer-bar shadow-[0_0_12px_rgba(255,46,147,0.7)]" />
          </div>
          <p className="text-[10px] font-semibold text-neutral-400 dark:text-neutral-500 tracking-wider">
            Loading store experience...
          </p>
        </div>
        
      </div>
    </div>
  );
}

